'use client';

import {
  useWebVitalsReport,
  type WebVitalsMetric,
} from '@gfiber/typesmith/web-vitals';

const WebVitals = () => {
  useWebVitalsReport((metric: WebVitalsMetric) => {
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push(metric);
  });

  return null;
};

export default WebVitals;
